// extracted by mini-css-extract-plugin
module.exports = {"search-dropdown":"SearchDropdown_search-dropdown__1lp6k","search-dropdown--open":"SearchDropdown_search-dropdown--open__2eWH_"};